var console = window.console || { log: function() {} };
/**
 * Scripts for the whole site
 */
import 'babel-polyfill';

import './menu/navigation';
import './misc/skip-link-focus-fix';
import './misc/misc-ui';
import './misc/isda-cookies';
import './misc/collateral-sop';
import './bookstore/cart';
import './bookstore/catalog-search';
import './forms/forms';
import './forms/event-registration-form';
import './forms/protocol-adherence-form';
import './forms/membership-form';
import './forms/cc-validation';
import './bookmarks/handleBookmarks';
/* ~=~=~=~=~=~
 * React
 ~=~=~=~=~=~ */
import React from 'react';
import ReactDom from 'react-dom';
/* Components */
import HeaderSearch from './header-search';

// creates array of parent categories
window.ParentCategories = ISDA_Main.categories.filter( category => {
	return 0 === category.parent && 1 !== category.term_id;
} );

// adds attribute children to object with array of child category ids.
ParentCategories.forEach( ( ParentCategory, index ) => {
	ParentCategories[ index ].children = ISDA_Main.categories.filter( category => {
		return ParentCategories[ index ].term_id === category.parent;
	} ).map( childCategory => {
		return childCategory.term_id;
	} );
} );

var HeaderSearchElement = document.getElementById( 'megamenu-search-wrap' );
if ( HeaderSearchElement ) {
	ReactDom.render( <HeaderSearch />, HeaderSearchElement );
}

(function() {
		if ( typeof NodeList.prototype.forEach === 'function' ) {
			return false;
		}
		NodeList.prototype.forEach = Array.prototype.forEach;
	}
)();
//Home page collapse only one latest post at a time.
$('.latest__header').click(function(e) {
	e.preventDefault();
	var currentIsActive = $(this).hasClass('collapsed');
	$('#accordion').find('.latest__content').removeClass('in');
	if( currentIsActive ) {
		$('#accordion').find('.latest__header').addClass('collapsed');
		$(this).removeClass('collapsed');
	}
});